var _defs, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictographPrimaryOneColorLightPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8e77fb;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.81,108.03c-15.13,0-27.44-12.31-27.44-27.44s12.31-27.44,27.44-27.44,27.44,12.31,27.44,27.44-12.31,27.44-27.44,27.44Zm0-41.88c-7.96,0-14.44,6.48-14.44,14.44s6.48,14.44,14.44,14.44,14.44-6.48,14.44-14.44-6.48-14.44-14.44-14.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.05,180.72c-11.82,0-23.2-3.46-33.05-10.01-13.14-8.72-21.96-21.23-25.53-36.17l12.64-3.02c2.79,11.68,9.73,21.49,20.08,28.36,7.91,5.27,16.72,7.91,26.09,7.83,12.91-.29,24.7-5.14,33.2-13.68.31-.67.81-1.5,1.62-2.27,4.4-4.18,7.69-9.95,10.36-18.15l12.36,4.03c-3.21,9.82-7.32,17.07-12.89,22.68-.29.61-.73,1.34-1.42,2.03-10.95,11.46-26.23,17.97-43.04,18.35-.14,0-.29,0-.44,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.91,
    y: 73.18,
    width: 61.12,
    height: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictographPrimaryOneColorLightPurple);
export default __webpack_public_path__ + "static/media/pictograph-primary-oneColor-lightPurple.0bb2f6d2fd0f004f67e0e6732a08080e.svg";
export { ForwardRef as ReactComponent };